import React, { useState } from 'react';
import { Col, Modal, ModalBody, ModalHeader, Nav, NavItem, NavLink, Row, TabContent, TabPane } from 'reactstrap';
import Highlight from 'react-highlight'
import { isJqueryNewResources, isJqueryOnClick, isJqueryOnload } from '../code/isCode';

const ModalJquery = ({ isOpen, setOpen }) => {
    const [tab, settab] = useState(1)
    return (<div>
        <Modal
            size='lg'
            centered
            isOpen={isOpen}
            toggle={setOpen}
        >
            <ModalHeader toggle={setOpen}>
                Tracker Sources Example
            </ModalHeader>
            <ModalBody>
                <Highlight innerHTML={true}>{'<p>Code Example JQuery : </p>'}</Highlight>
                <Nav tabs>
                    <NavItem style={{ cursor: "pointer" }}>
                        <NavLink
                            className={tab === 1 ? "active" : ""}
                            onClick={() => settab(1)}
                        >
                            Page View Source
                        </NavLink>
                    </NavItem>
                    <NavItem style={{ cursor: "pointer" }}>
                        <NavLink
                            className={tab === 2 ? "active" : ""}
                            onClick={() => settab(2)}
                        >
                            Click Link Source
                        </NavLink>
                    </NavItem>
                    <NavItem style={{ cursor: "pointer" }}>
                        <NavLink
                            className={tab === 3 ? "active" : ""}
                            onClick={() => settab(3)}
                        >
                            Customizing resources
                        </NavLink>
                    </NavItem>
                </Nav>
                <TabContent activeTab={tab}>
                    <TabPane tabId={1}>
                        <Row>
                            <Col sm="12">
                                <Highlight language="javascript">
                                    {`<script src="https://edts-tracker.vercel.app/js/bundle.js"></script>`}
                                </Highlight>
                                <Highlight language="javascript">
                                    {`${isJqueryOnload}`}
                                </Highlight>
                            </Col>
                        </Row>
                    </TabPane>
                    <TabPane tabId={2}>
                        <Row>
                            <Col sm="12">
                                <Highlight language="javascript">
                                    {`<script src="https://edts-tracker.vercel.app/js/bundle.js"></script>`}
                                </Highlight>
                                <pre>
                                    <Highlight language="javascript">
                                        {isJqueryOnClick}
                                    </Highlight>
                                </pre>
                            </Col>
                        </Row>
                    </TabPane>
                    <TabPane tabId={3}>
                        <Row>
                            <Col sm="12">
                                <Highlight language="javascript">
                                    {`<script src="https://edts-tracker.vercel.app/js/bundle.js"></script>`}
                                </Highlight>
                                <pre>
                                    <Highlight language="javascript">
                                        {isJqueryNewResources}
                                    </Highlight>
                                </pre>
                            </Col>
                        </Row>
                    </TabPane>
                </TabContent>
            </ModalBody>
        </Modal>
    </div >)
}

export default ModalJquery